import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { DiagramPayload } from '../models/diagram-payload';

export const DiagramEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[diagram] Edit'),
  requestFail: uniqueActionType('[diagram] Edit fail'),
  requestSuccess: uniqueActionType('[diagram] Edit success'),
  requestClearErrors: uniqueActionType('[diagram] Edit clear errors'),
  requestClear: uniqueActionType('[diagram] Edit clear')
};

export class DiagramEditAction implements PayloadAction {
  readonly type = DiagramEditActionTypes.request;

  constructor(public payload: SendByIdPayload<DiagramPayload>) {
  }
}

export class DiagramEditFailAction implements PayloadAction {
  readonly type = DiagramEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DiagramEditSuccessAction implements PayloadAction {
  readonly type = DiagramEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class DiagramEditClearErrorsAction implements PayloadAction {
  readonly type = DiagramEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class DiagramEditClearAction implements PayloadAction {
  readonly type = DiagramEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
